export enum CreditStudyStageName  {
  INITIALIZED = 'INITIALIZED',
  EXPIRED = 'EXPIRED',
  CALCULATED = 'CALCULATED',
};
